import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    getRes: null,
    getByAccessionRes: null,
    collectRes: null,
    receiveRes: null,
    rejectRes: null,
    updateStorageRes: null,
    disposeRes: null,
    bulkReceiveRes: null,
};

const slice = createSlice({
    name: 'labSpecimen',
    initialState,
    reducers: {
        getLabSpecimenRequest: (state) => { state.loading = true; },
        getLabSpecimenSuccess: (state, action) => { state.loading = false; state.getRes = action.payload; },
        getLabSpecimenFailure: (state, action) => { state.loading = false; state.getRes = action.payload; },
        resetGetLabSpecimen: (state) => { state.getRes = null; },

        getLabSpecimenByAccessionRequest: (state) => { state.loading = true; },
        getLabSpecimenByAccessionSuccess: (state, action) => { state.loading = false; state.getByAccessionRes = action.payload; },
        getLabSpecimenByAccessionFailure: (state, action) => { state.loading = false; state.getByAccessionRes = action.payload; },
        resetGetLabSpecimenByAccession: (state) => { state.getByAccessionRes = null; },

        collectLabSpecimenRequest: (state) => { state.loading = true; },
        collectLabSpecimenSuccess: (state, action) => { state.loading = false; state.collectRes = action.payload; },
        collectLabSpecimenFailure: (state, action) => { state.loading = false; state.collectRes = action.payload; },
        resetCollectLabSpecimen: (state) => { state.collectRes = null; },

        receiveLabSpecimenRequest: (state) => { state.loading = true; },
        receiveLabSpecimenSuccess: (state, action) => { state.loading = false; state.receiveRes = action.payload; },
        receiveLabSpecimenFailure: (state, action) => { state.loading = false; state.receiveRes = action.payload; },
        resetReceiveLabSpecimen: (state) => { state.receiveRes = null; },

        rejectLabSpecimenRequest: (state) => { state.loading = true; },
        rejectLabSpecimenSuccess: (state, action) => { state.loading = false; state.rejectRes = action.payload; },
        rejectLabSpecimenFailure: (state, action) => { state.loading = false; state.rejectRes = action.payload; },
        resetRejectLabSpecimen: (state) => { state.rejectRes = null; },

        updateStorageLabSpecimenRequest: (state) => { state.loading = true; },
        updateStorageLabSpecimenSuccess: (state, action) => { state.loading = false; state.updateStorageRes = action.payload; },
        updateStorageLabSpecimenFailure: (state, action) => { state.loading = false; state.updateStorageRes = action.payload; },
        resetUpdateStorageLabSpecimen: (state) => { state.updateStorageRes = null; },

        disposeLabSpecimenRequest: (state) => { state.loading = true; },
        disposeLabSpecimenSuccess: (state, action) => { state.loading = false; state.disposeRes = action.payload; },
        disposeLabSpecimenFailure: (state, action) => { state.loading = false; state.disposeRes = action.payload; },
        resetDisposeLabSpecimen: (state) => { state.disposeRes = null; },

        bulkReceiveLabSpecimenRequest: (state) => { state.loading = true; },
        bulkReceiveLabSpecimenSuccess: (state, action) => { state.loading = false; state.bulkReceiveRes = action.payload; },
        bulkReceiveLabSpecimenFailure: (state, action) => { state.loading = false; state.bulkReceiveRes = action.payload; },
        resetBulkReceiveLabSpecimen: (state) => { state.bulkReceiveRes = null; },
    }
});

export const {
    getLabSpecimenRequest, getLabSpecimenSuccess, getLabSpecimenFailure, resetGetLabSpecimen,
    getLabSpecimenByAccessionRequest, getLabSpecimenByAccessionSuccess, getLabSpecimenByAccessionFailure, resetGetLabSpecimenByAccession,
    collectLabSpecimenRequest, collectLabSpecimenSuccess, collectLabSpecimenFailure, resetCollectLabSpecimen,
    receiveLabSpecimenRequest, receiveLabSpecimenSuccess, receiveLabSpecimenFailure, resetReceiveLabSpecimen,
    rejectLabSpecimenRequest, rejectLabSpecimenSuccess, rejectLabSpecimenFailure, resetRejectLabSpecimen,
    updateStorageLabSpecimenRequest, updateStorageLabSpecimenSuccess, updateStorageLabSpecimenFailure, resetUpdateStorageLabSpecimen,
    disposeLabSpecimenRequest, disposeLabSpecimenSuccess, disposeLabSpecimenFailure, resetDisposeLabSpecimen,
    bulkReceiveLabSpecimenRequest, bulkReceiveLabSpecimenSuccess, bulkReceiveLabSpecimenFailure, resetBulkReceiveLabSpecimen,
} = slice.actions;

export default slice.reducer;
